import { Injectable } from '@angular/core';
import { State } from 'app/core/state';
import {
    SceValve,
    Scssv,
    StringEquipment,
    WellHead,
    Wrsv,
    XmasTree,
} from '../model/cdft.model';
import { isEmpty } from 'lodash';

@Injectable({ providedIn: 'root' })
export class StringEquipmentState
    extends State<StringEquipment>
    implements StringEquipment
{
    wellStringId: string;
    wellName: string;
    xmasTree: XmasTree;
    kwValve: SceValve;
    lmValve: SceValve;
    cValve: SceValve;
    ssValve: SceValve;
    wValve: SceValve;
    annulusA: WellHead;
    annulusB: WellHead;
    annulusC: WellHead;
    annulusD: WellHead;
    scssv: Scssv;
    wrsv: Wrsv;

    constructor() {
        super();
    }

    toSceValve(key: string) {
        const state: SceValve = (this[key] as SceValve) ?? ({} as SceValve);
        return {
            sizeIn: state?.sizeIn ?? null,
            ratingPsi: state?.ratingPsi ?? null,
            equipmentBrand: state?.equipmentBrand ?? null,
            actuatorModel: state?.actuatorModel ?? null,
            actuatorType: state?.actuatorType ?? null,
            oem: state?.oem ?? null,
            openingSec: state?.openingSec ?? null,
            openingCm: state?.openingCm ?? null,
            closingSec: state?.closingSec ?? null,
            closingCm: state?.closingCm ?? null,
            fullyOpen: state?.fullyOpen ?? null,
            fullyClose: state?.fullyClose ?? null,
            // jammed: state?.jammed ?? null,
            isActuated: state?.isActuated ?? null,
        };
    }

    toAnnulus(key: string) {
        const state: WellHead = (this[key] as WellHead) ?? ({} as WellHead);
        return {
            sizeIn: state?.sizeIn,
            ratingPsi: state?.ratingPsi,
            equipmentBrand: state?.equipmentBrand,
            actuatorModel: state?.actuatorModel,
            actuatorType: state?.actuatorType,
            oem: state?.oem,
            openingSec: state?.openingSec,
            openingCm: state?.openingCm,
            closingSec: state?.closingSec,
            closingCm: state?.closingCm,
            fullyOpen: state?.fullyOpen,
            fullyClose: state?.fullyClose,
            // jammed: state?.jammed,
            isActuated: state?.isActuated ?? null,
        };
    }

    isSssv() {
        try {
            return isEmpty(this.wrsv) ? true : false; 
        } catch (e) {
            return true;
        }
    }

    toSSV() {
        // if(!this.isSssv()) return this.toWRSV();
        return {
            isSssv: true,
            isSssvSelfEqualizing: this.scssv?.isSelfEqualize ?? null,
            ssvType: this.scssv?.mdSssvTypeId ?? null,
            ssvOem: this.scssv?.equipmentBrand ?? null,
            ssvSize: this.scssv?.sizeIn ?? null,
            cyclingTest: this.scssv?.cycling ?? null,
            clPressure: this.scssv?.clPressure ?? null,
            hydReturn: this.scssv?.hydraulicReturn ?? null,
            slamTest: this.scssv?.slamTest ?? null,
            blowingGas: this.scssv?.blowingGas ?? null,
            ...this.toWRSV()
        };
    }

    toWRSV() {
        return {
            isSssv: false,
            wrsvType: this.wrsv?.trsvType ?? null,
            wrsvOem: this.wrsv?.equipmentBrand ?? null,
            wrsvSize: this.wrsv?.sizeIn ?? null,
            installationDepth: this.wrsv?.installationDepth ?? null,
            installationAt: this.wrsv?.installationAtSvlntrsv ?? null,
        };
    }

    toHeaderForm() {
        return {
            xmtRating: this.xmasTree?.ratingPsi,
            xmtSize: this.xmasTree?.sizeIn,
            xmtOem: this.xmasTree?.oem,
            treeCapConn: this.xmasTree?.treecapConn,
            treeCapConnRemarks: this.xmasTree?.treecapConnRemarks,
            size: this.xmasTree?.treeCapConnSize,
            thread: this.xmasTree?.treeCapConnThread,
        };
    }
}
